<template>
  <div>
    <v-btn v-if="isAdd" fab bottom right large color="accent" fixed @click.stop="dialog = !dialog">
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn v-else @click.stop="dialog = !dialog" color="secondary"> edit </v-btn>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      scrollable
      max-width="500"
      transition="dialog-bottom-transition"
      @click:outside="resetForm"
    >
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text">
          <div>{{ isAdd ? 'Add new' : 'Edit' }} B2B Discount</div>
          <v-spacer></v-spacer>
          <v-card-actions v-if="!isAdd">
            <v-btn icon @click="deleteB2BDiscount"><v-icon color="red">delete</v-icon></v-btn>
          </v-card-actions>
        </v-card-title>
        <v-card-text>
          <v-form v-model="Form.valid" ref="prescriptionB2BDiscountForm">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="text-subtitle-2 mb-4">Select Organization</div>
                  <v-autocomplete
                    outlined
                    v-model="Form.organization_id"
                    :rules="[(v) => !!v || 'Organization is required']"
                    required
                    :items="corporateList"
                    item-text="name"
                    item-value="id"
                    label="Organization"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Discount Amount"
                    v-model="Form.discount_amount"
                    @keypress="onlyNumberAndDecimal"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="unitSelect"
                    item-text="text"
                    item-value="value"
                    persistent-hint
                    label="Discount Unit"
                    required
                    v-model="Form.discount_unit"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Total Usage Limit"
                    v-model="Form.total_usage_limit"
                    @keypress="onlyNumberAndDecimal"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Individual Usage Limit"
                    v-model="Form.individual_usage_limit"
                    @keypress="onlyNumberAndDecimal"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Usage Restriction Duration"
                    v-model="Form.usage_restriction_duration"
                    required
                    @keypress="onlyNumberAndDecimal"
                  />
                </v-flex>
                <v-flex>
                  <v-card-actions>
                    <v-btn color="accent" :disabled="!Form.valid" @click="addOrEditB2BDiscount">{{
                      isAdd ? 'Create' : 'Update'
                    }}</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Forms from '../../../../form/form';
import prescriptionDiscount from '../../../../services/prescriptionDiscount';

export default {
  data() {
    return {
      dialog: false,
      discountId: null,
      Form: new Forms({
        data: () => ({
          organization_id: null,
          discount_amount: 0,
          discount_unit: 'percentage',
          total_usage_limit: 0,
          individual_usage_limit: 0,
          usage_restriction_duration: 0,
        }),
      }),
      unitSelect: [
        { text: 'Percentage', value: 'percentage' },
        { text: 'Fixed Amount', value: 'amount' },
      ],
    };
  },
  props: {
    isAdd: {
      type: Boolean,
      default: true,
    },
    corporateList: {
      type: Array,
      default: () => [],
    },
    prescriptionB2BDiscount: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    resetForm() {
      this.Form.reset();
    },
    deleteMedicine() {
      console.log('delete');
    },
    onlyNumberAndDecimal(e) {
      const char = String.fromCharCode(e.keyCode);
      if (!/[0-9.]/.test(char)) {
        e.preventDefault();
      }
      if (char === '.' && e.target.value.includes('.')) {
        e.preventDefault();
      }
    },
    fillForm() {
      this.$nextTick(() => {
        this.$refs.prescriptionB2BDiscountForm.resetValidation();
      });
      this.discountId = this.prescriptionB2BDiscount.id;
      this.Form.organization_id = this.prescriptionB2BDiscount.organization_id;
      this.Form.discount_amount = this.prescriptionB2BDiscount.discount_amount;
      this.Form.discount_unit = this.prescriptionB2BDiscount.discount_unit;
      this.Form.total_usage_limit = this.prescriptionB2BDiscount.total_usage_limit;
      this.Form.individual_usage_limit = this.prescriptionB2BDiscount.individual_usage_limit;
      this.Form.usage_restriction_duration = this.prescriptionB2BDiscount.usage_restriction_duration;
    },
    preparePayload() {
      const payload = {
        organization_id: this.Form.organization_id,
        currency: 'THB',
        discount_amount: this.Form.discount_amount.length === 0 ? 0 : parseFloat(this.Form.discount_amount),
        discount_unit: this.Form.discount_unit,
        total_usage_limit: this.Form.total_usage_limit.length === 0 ? 0 : parseInt(this.Form.total_usage_limit),
        individual_usage_limit:
          this.Form.individual_usage_limit.length === 0 ? 0 : parseInt(this.Form.individual_usage_limit),
        usage_restriction_duration:
          this.Form.usage_restriction_duration.length === 0 ? 0 : parseInt(this.Form.usage_restriction_duration),
      };
      return payload;
    },
    async addOrEditB2BDiscount() {
      if (this.Form.valid) {
        const payload = this.preparePayload();
        if (this.isAdd) {
          prescriptionDiscount
            .create(payload)
            .then(() => {
              this.dialog = false;
              this.resetForm();
              this.$emit('success');
              this.$notify({
                title: 'Success',
                text: 'New prescription discount has been added successfully.',
                type: 'success',
              });
            })
            .catch((error) => {
              console.error('Error creating new prescription discount:', error);
              this.$notify({
                title: 'Error',
                text: `There was an error adding the new prescription discount. Please try again. \n${error.response.data.error.message}`,
                type: 'error',
              });
            });
        } else {
          prescriptionDiscount
            .update(this.discountId, payload)
            .then(() => {
              this.dialog = false;
              this.resetForm();
              this.$emit('success');
              this.$notify({
                title: 'Success',
                text: 'Prescription discount has been updated successfully.',
                type: 'success',
              });
            })
            .catch((error) => {
              console.error('Error updating prescription discount:', error);
              this.$notify({
                title: 'Error',
                text: `There was an error updating the prescription discount. Please try again. \n${error.response.data.error.message}`,
                type: 'error',
              });
            });
        }
      }
    },
    async deleteB2BDiscount() {
      this.$root
        .$confirm(
          'Delete Prescription Discount',
          `Are you sure you want to delete this prescription discount for <b>${this.prescriptionB2BDiscount.name}</b>? This action cannot be undone.`,
          { color: 'red' }
        )
        .then(async (confirm) => {
          if (confirm) {
            await prescriptionDiscount
              .deletePrescriptionDiscount(this.discountId)
              .then(() => {
                this.dialog = false;
                this.resetForm();
                this.$emit('success');
                this.$notify({
                  title: 'Success',
                  text: 'Prescription discount has been deleted successfully.',
                  type: 'success',
                });
              })
              .catch((error) => {
                console.error('Error deleting prescription discount:', error);
                this.$notify({
                  title: 'Error',
                  text: 'There was an error deleting the prescription discount. Please try again.',
                  type: 'error',
                });
              });
          }
        });
    },
  },
  watch: {
    dialog(val) {
      if (val && !this.isAdd && this.prescriptionB2BDiscount) {
        this.fillForm();
      }
    },
  },
};
</script>
